import axios from "axios"
import { Auth } from "aws-amplify"

//constantes
const headers = {
  "Content-Type": "application/json; charset=utf-8",
  Authorization: "",
}

const getToken = async verifySession => {
  if (verifySession) {
    await Auth.currentSession()
      .then(data => {
        headers.Authorization = data.idToken.jwtToken
      })
      .catch(error => {
        console.log(error)
        logoutSessionAD()
      })
  } else {
    headers.Authorization = (await Auth.currentSession()).idToken.jwtToken
  }
}
const logoutSessionAD = () => {
  try {
    Auth.signOut()
    removeSession()
  } catch (error) {
    console.log(error)
    removeSession()
  }
}
const removeSession = () => {
  window.sessionStorage.removeItem("username")
  window.sessionStorage.removeItem("name")
  window.sessionStorage.removeItem("user")
  window.sessionStorage.removeItem("menu")
  window.sessionStorage.removeItem("token")
  window.sessionStorage.removeItem("node")
  window.sessionStorage.removeItem("menuId")
}
export const apiCall = (method, url, json) => {
  return new Promise(async resolve => {
    await getToken(true)
    axios({
      method: method,
      url: url,
      data: JSON.stringify(json),
      mode: "no-cors",
      crossDomain: true,
      headers: headers,
    })
      .then(res => {
        resolve(res)
      })
      .catch(error => {
        resolve(error)
      })
  })
}
